import { Feature } from 'ol';
import LineString from 'ol/geom/LineString';
import Point from 'ol/geom/Point';
import { deepCopy } from '../utils/utils'

export default {
    state: {
        snapshotData: [], // 编辑器快照数据
        snapshotIndex: -1, // 快照索引
    },
    mutations: {
        // 撤销
        undo(state) {
            if (state.snapshotIndex >= 0) {
                state.snapshotIndex--;
                this.commit('simulation/reRendering', state.snapshotData[state.snapshotIndex]);
            }
            // 切换地图模式
            this.commit("simulation/setMapMode","draw");
        },
        // 重做
        redo(state) {
            if (state.snapshotIndex < state.snapshotData.length - 1) {
                state.snapshotIndex++
                this.commit('simulation/reRendering',state.snapshotData[state.snapshotIndex]);
            }
            // 切换地图模式
            this.commit("simulation/setMapMode","draw");
        },
        // 记录快照
        recordSnapshot(state) {
            let source=state.drawSource;
            let features=source.getFeatures();
            let featuresData=[];
            features.forEach(element => {
                let feature=element.clone();
                feature.setId(element.getId());
                featuresData.push(feature);
            });
            // 添加新的快照
            state.snapshotData[++state.snapshotIndex] = featuresData;
            // 在 undo 过程中，添加新的快照时，要将它后面的快照清理掉
            if (state.snapshotIndex < state.snapshotData.length-1) {
                state.snapshotData = state.snapshotData.slice(0, state.snapshotIndex + 1)
            }
        },
        // 根据数据重新渲染地图
        reRendering(state,data){
            console.log("dsfdsf");
            // 清空地图
            let source=state.drawSource;
            source.clear();
            // 因为还有store中存储的要素，需要重新进行保存
            let lines=[]; // 管道数组
            let common=[];
            let input=[];
            let unknownInput=[];
            let output=[];
            if(data){
                // 增加新的数据
                for(let f of data){
                    let tempF=f.clone();
                    tempF.setId(f.getId());
                    source.addFeature(tempF);
                    let _type=tempF.get("_type");
                    switch(_type){
                        case "line":
                            lines.push(tempF);
                            break;
                        case "input":
                            input.push(tempF);
                            break;
                        case "unknownInput":
                            unknownInput.push(tempF);
                            break;
                        case "unknowOutput":
                        case "output":
                            output.push(tempF);
                            break;
                        default:
                            common.push(tempF);
                            break;
                    }
                }
            }
            // 管道
            this.commit("simulation/setLines",lines);
            // 提交节点保存
            let nodes={
                "common":common , // 通用节点列表
                "input":input, // 输入节点列表
                "unknownInput":unknownInput, // 待求输入节点列表
                "output":output, // 输出节点列表
            }; // 节点
            this.commit("simulation/setNodes",nodes);

        }
    },
}